/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import type { Provider } from '@ethersproject/providers'
import type { ISupplierContract, ISupplierContractInterface } from '../ISupplierContract'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_nmx',
        type: 'address',
      },
      {
        internalType: 'uint128',
        name: '_nmxPerSecond',
        type: 'uint128',
      },
      {
        internalType: 'uint40',
        name: '_fromTime',
        type: 'uint40',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'nmx',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'nmxPerSecond',
        type: 'uint128',
      },
      {
        indexed: false,
        internalType: 'uint40',
        name: 'fromTime',
        type: 'uint40',
      },
    ],
    name: 'Created',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint128',
        name: 'oldRate',
        type: 'uint128',
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'newRate',
        type: 'uint128',
      },
    ],
    name: 'RateUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'oldRouter',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'newRouter',
        type: 'address',
      },
    ],
    name: 'RouterChanged',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakingRouter',
        type: 'address',
      },
    ],
    name: 'changeRouter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fromTime',
    outputs: [
      {
        internalType: 'uint40',
        name: '',
        type: 'uint40',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nmxPerSecond',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
    ],
    name: 'recoverFunds',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingRouter',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'startTime',
    outputs: [
      {
        internalType: 'uint40',
        name: '',
        type: 'uint40',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint40',
        name: 'maxTime',
        type: 'uint40',
      },
    ],
    name: 'supplyNmx',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_nmxPerSecond',
        type: 'uint128',
      },
    ],
    name: 'updateRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export class ISupplierContract__factory {
  static readonly abi = _abi
  static createInterface(): ISupplierContractInterface {
    return new utils.Interface(_abi) as ISupplierContractInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ISupplierContract {
    return new Contract(address, _abi, signerOrProvider) as ISupplierContract
  }
}
